<template>
  <div id="renewSMIME">
    <b-container class="container--max-lg">
      <div class="c-dashboard__card">
      </div>
      <h1 style="text-align: center" v-if="this.validityDate!==''">Your new Certificate is valid until:</h1>
      <h2 style="text-align: center" v-if="this.validityDate!==''">{{validityDate}}</h2>
      <b-form @submit.prevent="onSubmit" :validated="wasValidated"
              v-if="this.validityDate===''">
        <b-card>
          <b-card-title class="mb-2">
            {{ $t("lang.label_renew_SMIME_title") }}
          </b-card-title>
          <b-form-group>
            <b-form-textarea name="contactMessage" class="mb-4" v-model="pemCertificate" type="text" required
                             :placeholder="$t('lang.label_renew_SMIME_placeholder')" rows="20"></b-form-textarea>
            <b-form-invalid-feedback>{{ $t("lang.label_placeholder_enterText") }}</b-form-invalid-feedback>
            <div class="mt-2">
              <b-button type="submit" size="lg" variant="primary"> {{ $t("lang.label_renew_SMIME") }}</b-button>
            </div>
          </b-form-group>
        </b-card>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import API from "@/api";
import ServerResponse from "@/store/ServerResponse";

export default {
  name: "RenewAdminCertificate",
  data() {
    return {
      /* Selected existing certificate */
      pemCertificate: "",
      wasValidated: false,
      validityDate: "",
    }
  },
  methods: {
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }
      this.renewCertificateInDB();
    },
    renewCertificateInDB() {
      API.renewAdminCertificate(this.$route.query.token, this.pemCertificate).then(
          result => {
            this.validityDate = result.data;
            if (this.validityDate==="")
            {
              this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_renew_cert_error"));
            }
          }
      )
          .catch(error => {
            this.$router.push({
                                name: "error",
                                params: {serverResponse: new ServerResponse(error.response.data)}
                              });
          });
    }
  }
}
</script>

<style scoped>

</style>